<template>
  <div class="legislacao">
    <div class="container">
      <h1 class="display-1 my-3">Legislação</h1>
      <v-divider></v-divider>
      <v-layout wrap class="my-4">
        <v-flex xs12 md3 v-for="item in itemsLegislacao" :key="item.decreto">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 12 : 2" class="ma-2">
              <v-card-text>
                <div class="subtitle-1 teal--text">{{ item.titulo }}</div>
                <div class="subtitle-2 grey--text">{{ item.texto }}</div>
              </v-card-text>
              <v-card-actions>
                <v-btn text :href="item.url" target="_blank">
                  <v-icon left class="grey--text">visibility</v-icon>
                  <span class="grey--text">Visualizar</span>
                </v-btn>
            
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemsLegislacao: {
      type: Array,
    },
  },
  data() {
    return {
      tituloDecreto: "",
      sinopseDecreto: "",
      linkDecreto: "",
      items: [
        {
          decreto: "INSTRUÇÃO NORMATIVA DRM/SMF Nº 03, DE 20 DE DEZEMBRO DE 2013",
          sinopse:
            "Dispõe Sobre A Obrigatoriedade Da Declaração Eletrônica De Serviços De Instituições Financeiras (Des-If), Para As Instituições Financeiras E Equiparadas, Autorizadas A Funcionar Pelo Banco Central - Bacen, E Para As Demais Pessoas Jurídicas Obrigadas A Utilizar O Plano De Contas Das Instituições Do Sistema Financeiro Nacional - Cosif",
          link: "@/assets/banner_hero.png",
        },
      ],
    };
  },
  // methods: {
  //   baixarPDF() {
  //     let link = document.createElement("a");
  //     link.href = "/LC5.687, 20 DE DEZ 2021.pdf";
  //     link.download = "decreto";
  //     link.click();
  //   },
  // },
};
</script>
